import React, { useEffect } from "react";
import "./Service.css";
import Header from "./Header";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import Breadcrumbs from "./Products/Breadcrumbs";
function Service() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        // <div className="service-page-container">
        //   {/* Sticky Header */}
        //   <div className="service-header-fixed">
        //     {window.location.pathname === "/" ? "" : <Header />}
        //   </div>

        <div className="container-fluid p-0">
            <div className="sticky-top">
                {window.location.pathname === "/" ? "" : <Header />}
            </div>

            <section id="service-section">
                <div className="service-main-container"> {window.location.pathname !== "/" && <Breadcrumbs />}
                    <header className="service-section-header" data-aos="fade-up">
                        <h2 className="service-main-heading">Our Services</h2>
                        <p className="service-main-description">
                            Whether you're envisioning a cozy home retreat or a vibrant
                            office space, we invite you to join us in crafting a story
                            through design. Explore our services and let’s transform your
                            space into a work of art.
                        </p>
                    </header>

                    {/* Overall Wrapper Card */}
                    <div className="service-wrapper" data-aos="fade-up">
                        <div className="service-row">
                            {/* Residential */}
                            <div
                                className="service-column"
                                data-aos="zoom-in"
                                data-aos-delay="100"
                            >
                                <div className="service-card service-card-blue">
                                    <div className="service-icon">
                                        <i className="bi bi-house"></i>
                                    </div>
                                    <h3 className="service-title">
                                        Residential Interiors
                                    </h3>
                                    <p className="service-descriptions">
                                        At indec, we believe your home should reflect your lifestyle, comfort, and personal taste.
                                        Our residential interior services are designed to transform everyday living spaces into beautifully styled, functional, and comfortable environments.
                                    </p>
                                    <p className="service-descriptions">
                                        "Bringing comfort, style and protection into every home with reliable residential interior solutions."
                                    </p>
                                </div>
                            </div>

                            {/* Commercial */}
                            <div
                                className="service-column"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                <div className="service-card service-card-orange">
                                    <div className="service-icon">
                                        <i className="bi bi-buildings"></i>
                                    </div>
                                    <h3 className="service-title">
                                        Commercial Interiors
                                    </h3>
                                    <p className="service-descriptions">
                                        At indec, we create functional and visually appealing commercial interiors that enhance your brand identity,
                                        improve customer experience, and support efficient daily operations.
                                        We understand that commercial spaces demand durability, practicality, and aesthetics together.
                                    </p>
                                    <p className="service-descriptions">
                                        "Creating professional spaces that work, inspire, and leave a lasting impression."
                                    </p>
                                </div>
                            </div>

                            {/* Space Planning */}
                            <div
                                className="service-column"
                                data-aos="zoom-in"
                                data-aos-delay="300"
                            >
                                <div className="service-card service-card-green">
                                    <div className="service-icon">
                                        <i className="bi bi-columns-gap"></i>
                                    </div>
                                    <h3 className="service-title">Industrial Interiors</h3>
                                    <p className="service-descriptions">
                                        At indec, we also offer practical and durable interior solutions for industrial environments
                                        where performance, safety, and long-term strength are critical.
                                    </p>
                                    <p className="service-descriptions">
                                        "Strong interiors for strong industries - built for performance, not just looks."
                                    </p>
                                </div>
                            </div>

                            {/* Styling */}
                            <div
                                className="service-column"
                                data-aos="zoom-in"
                                data-aos-delay="400"
                            >
                                <div className="service-card service-card-purple">
                                    <div className="service-icon">
                                        <i className="bi bi-building-gear"></i>
                                    </div>
                                    <h3 className="service-title">Installation & Maintenance</h3>
                                    <p className="service-descriptions">
                                        We provide expert installation and reliable maintenance for curtains, aluminium frames, mosquito nets, and window fittings.
                                        Our team ensures neat finishing, smooth operation, and long-lasting performance.
                                        Complete installation, repair, replacement, and maintenance for all types of interiors.
                                    </p>
                                    <p className="service-descriptions">"We don’t just install — we ensure lasting performance."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {window.location.pathname === "/" ? "" : <Footer />}
        </div>
    );
}

export default Service;
